import React from 'react'

const SymbolSpan = (props) => {
  return <span className='symbol'>{props.children}</span>
}

const IndicatorsSpan = (props) => {
  return <span className='indicator'>{props.children}</span>
}

const ComparisonSpan = (props) => {
  return <span className='comparison'>{props.children}</span>
}

const TriggerSpan = (props) => {
  return <span className='trigger'>{props.children}</span>
}

const ConjunctionSpan = (props) => {
  return <span className='conjunction'>{props.children}</span>
}

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText()
  let matchArr, start
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index
    if (matchArr[0].toLowerCase() === 'if' && start === 0) {
      continue
    }
    callback(start, start + matchArr[0].length)
  }
}

const comparisonOperators = [
  'cross', 'crosses', 'go', 'goes', 'move', 'moves', 'rise', 'rises', 'drop', 'drops', 'moves', 'above', 'up','down', 'over', 'under',
  'less', 'below', 'smaller', 'larger', 'higher', 'bigger', 'more', 'above', 'greater', 'equals', 'equal', 'less than',
  'smaller than', 'lower than', 'larger than', 'higher than', 'bigger than', 'more than', 'greater than', 'equals than', 'equal than'
]

const conjunctions = ['and', 'or']

export const decorateIndicators = (array) => {
  const indicatorsRegex = new RegExp(array.map(row => `\\b${row}\\b`).join('|'), 'ig')
  function indicatorsStrategy(contentBlock, callback) {
    findWithRegex(indicatorsRegex, contentBlock, callback)
  }
  return {
    strategy: indicatorsStrategy,
    component: IndicatorsSpan
  }
}
export const decorateComparison = () => {
  const comparisonRegex = new RegExp(comparisonOperators.map(row => `\\b${row}\\b`).join('|'), 'ig')
  function comparisonStrategy(contentBlock, callback) {
    findWithRegex(comparisonRegex, contentBlock, callback)
  }
  return {
    strategy: comparisonStrategy,
    component: ComparisonSpan
  }
}
export const decorateConjunctions = () => {
  const conjunctionRegex = new RegExp(conjunctions.map(row => `\\b${row}\\b`).join('|'), 'ig')
  function conjunctionStrategy(contentBlock, callback) {
    findWithRegex(conjunctionRegex, contentBlock, callback)
  }
  return {
    strategy: conjunctionStrategy,
    component: ConjunctionSpan
  }
}
export const decorateTriggers = (has_coin) => {
  const regex = has_coin ? '@' : '@|#|&'
  const triggerRegex = new RegExp(regex, 'ig')
  function triggerStrategy(contentBlock, callback) {
    findWithRegex(triggerRegex, contentBlock, callback)
  }
  return {
    strategy: triggerStrategy,
    component: TriggerSpan
  }
}

export const decorateSymbols = (regex) => {
  function symbolStrategy(contentBlock, callback) {
    findWithRegex(regex, contentBlock, callback)
  }
  return {
    strategy: symbolStrategy,
    component: SymbolSpan
  }
}
